import AclName from '../../acl/AclName';
import { ACCIDENT_INSURANCE_ROUTES } from '../../modules/accident-insurance/constants/routes';

const breadcrumb = [
  { title: 'Kadry' },
  { title: 'Składka wypadkowa', url: ACCIDENT_INSURANCE_ROUTES.LIST.path },
];

export default [
  {
    path: ACCIDENT_INSURANCE_ROUTES.LIST.path,
    name: ACCIDENT_INSURANCE_ROUTES.LIST.name,
    component: () => import('../../modules/accident-insurance/views/AccidentInsurancesView.vue'),
    meta: {
      acl: AclName.StaffPageAccidentInsurancesList,
      breadcrumb,
      pageTitle: 'Składka wypadkowa',
    },
  },
  {
    path: ACCIDENT_INSURANCE_ROUTES.ADD.path,
    name: ACCIDENT_INSURANCE_ROUTES.ADD.name,
    component: () => import('../../modules/accident-insurance/views/AccidentInsuranceFormView.vue'),
    meta: {
      acl: AclName.StaffPageAccidentInsurancesEdit,
      breadcrumb,
      pageTitle: 'Dodawanie',
    },
    props: route => ({ duplicateId: route.query.duplicate ? Number(route.query.duplicate) : null }),
  },
  {
    path: ACCIDENT_INSURANCE_ROUTES.EDIT.path,
    name: ACCIDENT_INSURANCE_ROUTES.EDIT.name,
    component: () => import('../../modules/accident-insurance/views/AccidentInsuranceFormView.vue'),
    meta: {
      acl: AclName.StaffPageAccidentInsurancesEdit,
      breadcrumb,
      pageTitle: 'Edycja',
    },
    props: route => ({ id: Number(route.params.id) }),
  },
];
